import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { RoleUtil } from './role.util';

/**
 * Bouton « + » global (§3.2) : depuis n'importe quel écran, trois choix — Vente, Dépense, Encaissement.
 * Masqué sur les formulaires de saisie et sur le détail mobile d'une transaction.
 */
@Component({
  selector: 'bay-ajout-rapide',
  template: `
    <button *ngIf="visible" type="button" class="bay-fab" (click)="ouvert = true" aria-label="Ajouter : vente, dépense, encaissement ou assistant IA"
      aria-haspopup="dialog">
      <span class="material-symbols-outlined" aria-hidden="true">add</span>
    </button>
    <bay-bottom-sheet [open]="ouvert" titre="Ajouter" sousTitre="Que voulez-vous enregistrer ?" (closed)="ouvert = false">
      <div class="bay-ajout-choix">
        <button type="button" class="bay-ajout-btn" (click)="aller('/finances/ajout', { type: 'revenu' })">
          <span class="material-symbols-outlined bay-ajout-ic bay-ajout-ic-v" aria-hidden="true">trending_up</span>
          <span><strong>Vente</strong><span class="bay-ajout-aide">Poulets, œufs, récolte, animaux… comptant ou à crédit</span></span>
        </button>
        <button type="button" class="bay-ajout-btn" (click)="aller('/finances/ajout', { type: 'depense' })">
          <span class="material-symbols-outlined bay-ajout-ic bay-ajout-ic-d" aria-hidden="true">trending_down</span>
          <span><strong>Dépense</strong><span class="bay-ajout-aide">Aliment, salaires, soins, carburant… avec photo du reçu</span></span>
        </button>
        <button type="button" class="bay-ajout-btn" (click)="aller('/finances/impayes')">
          <span class="material-symbols-outlined bay-ajout-ic bay-ajout-ic-e" aria-hidden="true">payments</span>
          <span><strong>Encaissement</strong><span class="bay-ajout-aide">Un client règle une vente à crédit ou une facture</span></span>
        </button>
        <button *ngIf="voitAssistant" type="button" class="bay-ajout-btn" (click)="ouvert = false; assistantOuvert = true" data-etat="choix-assistant">
          <span class="material-symbols-outlined bay-ajout-ic bay-ajout-ic-e" aria-hidden="true">auto_awesome</span>
          <span><strong>Assistant IA</strong><span class="bay-ajout-aide">Posez une question sur vos chiffres : impayés, dépenses, production…</span></span>
        </button>
      </div>
    </bay-bottom-sheet>
    <bay-bottom-sheet [open]="assistantOuvert" titre="Assistant IA" sousTitre="Vos questions sur la ferme" (closed)="assistantOuvert = false">
      <bay-assistant [ouvert]="assistantOuvert"></bay-assistant>
    </bay-bottom-sheet>
  `
})
export class AjoutRapideComponent implements OnDestroy {
  ouvert = false;
  assistantOuvert = false;
  /** L'assistant est réservé à l'administrateur et au comptable (le serveur refuse les autres) */
  get voitAssistant(): boolean { return RoleUtil.voitFinances(); }
  private url = '';
  private sub: Subscription;

  /** Écrans où le bouton gênerait (formulaires, grille) */
  private static readonly MASQUE = [/^\/finances\/ajout/, /^\/finances\/tableau/, /^\/factures\/(creation|edition)/, /^\/ged\/upload/,
    /^\/account/, /^\/betail\/(ajout|modification)/];

  constructor(private router: Router) {
    this.url = router.url;
    this.sub = router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      this.url = (e as NavigationEnd).urlAfterRedirects;
      this.ouvert = false;
    });
  }

  get visible(): boolean {
    if (!RoleUtil.peutModifier()) return false;
    const [chemin, requete] = this.url.split('?');
    // Page de détail d'une transaction (mobile) : ses actions sont fixées en bas
    if (requete && /(^|&)detail=/.test(requete)) return false;
    return !AjoutRapideComponent.MASQUE.some(r => r.test(chemin));
  }

  aller(chemin: string, params?: any): void {
    this.ouvert = false;
    this.router.navigate([chemin], { queryParams: params });
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }
}
